import React from 'react'
import Link, { navigateTo } from 'gatsby-link'
import { withPrefix } from 'gatsby-link'

//  Components
import stateHeaderBackgroundURL, { ReactComponent as StateHeaderBackground } from '../../assets/svg/state-header-bg.svg'

//  Styles
import styles from './StateHeader.module.scss'

const StateHeader = ( props ) => (
  <div className={ `${styles.state__header} l-full` }>
    <div className={ styles.state__header__content }>
      <h1 className={ styles.state__header__title }>{ props.title }</h1>
      <select onChange={(e) => navigateTo(e.target.value) } className={ styles.state__header__select }>
        <option>Select a New State</option>
      { props.states
        .filter(node => node.node.id !== props.id)
        .map((node) =>
        <option key={ node.node.id } value={ withPrefix(`/state/${node.node.url}`) }>{ node.node.title }</option>
      )}
      </select>
    </div>
    <figure className={ styles.state__icon }>
      <img src={ withPrefix(`/img/states/${ props.id }.png`) } alt="" />
    </figure>
    <StateHeaderBackground className={ styles.state__header__background } />
  </div>
)

export default StateHeader


// WEBPACK FOOTER //
// ./src/components/StateHeader/StateHeader.js